"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _react = _interopRequireWildcard(require("react"));
const _excluded = ["className", "style", "href"];
/* eslint-disable react/no-children-prop */
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const HTMLRenderer = ({
  html
}) => {
  // ✅ 改进：使用 useMemo 缓存解析结果，支持 SSR
  const parsedContent = (0, _react.useMemo)(() => {
    if (!html) return null;

    // 服务端和客户端都执行解析
    return parseHTML(html);
  }, [html]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, parsedContent);
};

// ✅ 将解析函数提取到组件外，支持 SSR
const parseHTML = htmlString => {
  // 如果是服务端环境，使用简单的正则替换
  if (typeof window === 'undefined') {
    // SSR 环境：使用简化解析
    return /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: htmlString
      }
    });
  }

  // 客户端环境：使用完整的 DOM 解析
  let safeHtmlString = htmlString.replace(/<Link/g, '<tpm-link').replace(/<\/Link>/g, '</tpm-link>').replace(/<Text/g, '<tpm-text').replace(/<\/Text>/g, '</tpm-text>');
  const parser = new DOMParser();
  const doc = parser.parseFromString(safeHtmlString, 'text/html');
  let nodeCounter = 0;
  const walk = (node, index) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent || '';
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node;
      const tagName = element.tagName.toLowerCase();
      const props = {};
      const key = `node-${nodeCounter++}`;
      Array.from(element.attributes).forEach(attr => {
        props[attr.name === 'class' ? 'className' : attr.name] = attr.value;
      });
      if (tagName === 'tpm-text') {
        const className = props.className,
          style = props.style,
          type = props.type;
        return /*#__PURE__*/_react.default.createElement(_tpmProductIntl.Text, {
          key: key,
          className: className,
          style: style,
          type: type
        }, Array.from(element.childNodes).map(walk));
      }
      if (tagName === 'tpm-link') {
        const className = props.className,
          style = props.style,
          href = props.href,
          otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
        return /*#__PURE__*/_react.default.createElement(_tpmProductIntl.Link, Object.assign({
          key: key,
          className: className,
          style: style,
          href: href,
          target: "_blank",
          "report-event": "click_link",
          "report-ext1": href
        }, otherProps), Array.from(element.childNodes).map(walk));
      }
      if (tagName === 'p') {
        return /*#__PURE__*/_react.default.createElement("p", Object.assign({
          key: `p-${index}`
        }, props), Array.from(element.childNodes).map(walk));
      }
      if (tagName === 'br') {
        return /*#__PURE__*/_react.default.createElement("br", Object.assign({
          key: `br-${index}`
        }, props));
      }
      return /*#__PURE__*/_react.default.createElement(tagName, _objectSpread(_objectSpread({}, props), {}, {
        key: `${tagName}-${index}`
      }), Array.from(element.childNodes).map((child, i) => walk(child, i)));
    }
    return null;
  };
  return Array.from(doc.body.childNodes).map((node, i) => walk(node, i));
};
var _default = exports.default = HTMLRenderer;